import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Input,
  Table,
  Label,
  Form,
  Button,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import CustomTable from "../../Custom/TableWithRemotePagination";
import * as Yup from "yup";
// import CustomInput from "Custom/CustomInput"
import { Field, FormikProvider, useFormik } from "formik";
import CustomSelect from "Custom/CustomSelect";
import { Spin } from "antd";
import { GET_INVOICE_LIST } from "helpers/url_helper";
import { get } from "helpers/api_helper";
import moment from "moment";
import { useSelector } from "react-redux";
import { GET_INVOICE_DETAILS } from "helpers/url_helper"
const InvoiceList = (props) => {
  const navigate = useNavigate();
  const [totalSize, setTotalSize] = useState(3);
  const [hide, setHide] = useState(1);
  var Auth = JSON.parse(localStorage.getItem("authUser"));
  const [isLoading, setIsLoading] = useState(false);
  // const [invoiceList, setInvoiceList] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(10);
  const [invoiceListData, setInvoiceListData] = useState([]);
  const [search, setSearch] = useState("");
  const [invoiceDetail, setInvoiceDetail] = useState([])
  const [addressline, setAddressline] = useState([])
  const AuthUser = JSON.parse(localStorage.getItem("authUser"));
  const userCompanyInfo = JSON.parse(localStorage.getItem("userCompanyInfo"));
  const [invoiceData, setInvoiceData] = useState([])
  const companyid = useSelector((state) => state?.Login?.currentCompanyId);
  const [ID, setID] = useState("")
  const formatAddress = item => {
    var addressline = item.org_billing_address
    const addressParts = [
      addressline?.address_line_1,
      addressline?.address_line_2,
      addressline?.address_line_3,
      [addressline?.city?.city_name, addressline?.state?.state_name]
        .filter(Boolean)
        .join(", "),
      [addressline?.country?.name, addressline?.zip_code].filter(Boolean).join(" - "),
      addressline?.phone,
    ].filter(Boolean)

    return addressParts.join(",<br/>")
  }
  let Cid =
    AuthUser?.org === true ? userCompanyInfo?.organization?.id : companyid;

  const columns = [
    {
      text: (
        <>
          <Input
            type="checkbox"
            className="form-check-input"
            id="Add"
            checked={false}
          />
          &nbsp; Date
        </>
      ),
      dataField: "Date",
      style: { minWidth: "150px" },
    },
    {
      text: "Invoice No.",
      dataField: "Invoice",
      style: { minWidth: "150px" },
    },
    {
      text: "Status",
      dataField: "Status",
      style: { minWidth: "150px" },
    },

    {
      text: "Amount",
      dataField: "Amount",
      style: { minWidth: "150px" },
    },
    {
      text: "Actions",
      dataField: "Actions",
      style: { maxWidth: "73px", minWidth: "73px" },
    },
  ];

  const validationSchemaFilter = Yup.object().shape({});
  const formikFilter = useFormik({
    validationSchema: validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      Status: "",
      Search: "",
      SearchByColumn: "",
    },
    validateOnBlur: false,
  });

  const {
    setFieldValue,
    values: { Search, Status, SearchByColumn },
  } = formikFilter;

  useEffect(() => {
    if (Cid) {
      getData();
    }
  }, [Search, SearchByColumn, Status, Cid]);

  const InvoiceOptions = [{ label: "Invoice No.", value: "invoice_no" }];

  const statusOption = [
    { label: "DRAFT", value: "draft" },
    { label: "SENT", value: "sent" },
  ];


  const getInvoiceDetail = id => {
    setIsLoading(true);

    get(GET_INVOICE_DETAILS + `/${id}`).then(res => {
      if (res.status === 200) { 
        setInvoiceDetail(res.data)
      }
      setIsLoading(false);
    })
     
  }

  const getData = (page = 1, sizePerPage = 10) => {
    setIsLoading(true);
    get(
      GET_INVOICE_LIST +
        "?page=" +
        page +
        "&paginate=" +
        sizePerPage +
        (search ? "&search=" + search : "") +
        (Status ? "&status_filter=" + Status : "") +
        "&contact_id=" +
        Cid
    )
      .then((res) => {
        if (res?.data?.data?.length > 0) {
          setInvoiceListData(
            res?.data?.data?.map((e, index) => {
              return {
                Date: (
                  <>
                    <Input
                      type="checkbox"
                      className="form-check-input"
                      id="Add"
                      checked={false}
                    />{" "}
                    &nbsp;
                    {e.invoice_date ? moment(e.invoice_date).format("DD-MMM-YYYY").replace(/^\-/, "") : ""}
                  </>
                ),
                Invoice: (
                  <>
                    {AuthUser?.permissions?.filter(
                      x => x.resource_id == 9 && x.view_per == 1
                    )?.length > 0 ? (
                      <Link
                        onClick={() => {
                          setHide(2)
                          getInvoiceDetail(e.id)
                          setID(e.id)
                        }} to={""}>
                        {e.invoice_no}
                      </Link>
                    ) : (
                      e.invoice_no
                    )}
                  </>
                ),
                // CustomerName: e.contact.company_name,
                Status: (
                  <>
                    <text
                      style={{
                        color:
                          e.invoice_status === "draft"
                            ? "grey"
                            : e.invoice_status === "issued"
                            ? "#798ad8"
                            : "green",
                        textTransform: "uppercase",
                      }}
                    >
                      {e.invoice_status}
                    </text>
                  </>
                ),
                Amount: (
                  <>
                    Rs.{" "}
                    {e.grand_total
                      ? parseFloat(e.grand_total).toFixed(2)
                      : "0.00"}
                  </>
                ),
                Actions: (
                  <>
                    <div className="d-flex">
                      {/* {isDraft ? ( */}
                      {e.invoice_status.toLowerCase() !== "sent" &&
                      Auth?.permissions?.filter(
                        (x) => x.resource_id == 12 && x.edit_per == 1
                      )?.length > 0 ? (
                        <Link
                          className="btn btn-secondary waves-effect waves-light btn btn-secondary"
                          style={{
                            width: "25px",
                            height: "25px",
                            padding: "0px",
                          }}
                          to={`/edit-invoice/${e.id}`}
                          title="Edit"
                        >
                          <i
                            className="fas fa-edit"
                            style={{ color: "#17a98c" }}
                          ></i>
                        </Link>
                      ) : (
                        <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>
                      )}
                      {/* ) : (
                          ""
                        )} */}
                      &nbsp;
                      {/* {Auth?.permissions?.filter(
                        (x) => x.resource_id == 5 && x.delete_per == 1
                      )?.length > 0 ? (
                        <>
                          &nbsp;
                          <Button
                            className="btn btn-secondary waves-effect waves-light btn btn-secondary"
                            style={{
                              width: "25px",
                              height: "25px",
                              padding: "0px",
                            }}
                            title="Delete"
                            onClick={() => {
                              // delete_po(e.id)
                            }}
                          >
                            <i
                              className="fas fa-trash-alt"
                              style={{
                                color: "red",
                              }}
                            ></i>
                          </Button>
                        </>
                      ) : (
                        ""
                      )} */}
                    </div>
                  </>
                ),
              };
            })
          );
          setInvoiceData(res.data.data)
          setTotalSize(res?.data?.total);
          setIsLoading(false);
        } else {
          setInvoiceListData([]);
          setTotalSize(0);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
    setCurrentPage(page);
    setCurrentSizePerPage(sizePerPage);
  };

  return (
    <React.Fragment>
      <Spin size="large" spinning={isLoading} tip={"Loading..."}>
        <div className="page-content">
          <MetaTags>
            <title>{"Invoice"} | Katlax OMS</title>
          </MetaTags>

          <Container fluid>
            {hide === 1 ? (
              <>
                <Row className="mt-3">
                  <Col lg={6}>
                    <div className="mt-2" style={{ fontSize: "large" }}>
                      <b>Invoice</b>
                    </div>
                  </Col>
                  <Col lg={6} style={{ textAlign: "end" }}>
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        navigate("/add-invoice");
                      }}
                    >
                      Add Invoice
                    </button>
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col className="col-12">
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row>
                          <Col lg={12}>
                            <Row>
                              <Col lg={3} sm={6} md={3}>
                                <div className="form-group has-search">
                                  <span className="fa fa-search form-control-feedback"></span>
                                  {/* <Field
                                    type="text"
                                    name="Search"
                                    component={CustomInput}
                                    placeholder="Search"
                                  /> */}
                                  <Input
                                    type="text"
                                    name="Search"
                                    className="form-control"
                                    placeholder="Search"
                                    value={Search}
                                    onChange={(e) => {
                                      //setSearch(e.target.value)
                                      formikFilter.setFieldValue(
                                        "Search",
                                        e.target.value
                                      );
                                    }}
                                  />
                                </div>
                              </Col>
                              <Col lg={2} sm={6} md={2}>
                                <Field
                                  name="SearchByColumn"
                                  placeholder={"By Column"}
                                  component={CustomSelect}
                                  options={InvoiceOptions}
                                />
                              </Col>
                              <Col lg={2} md={2}>
                                <Field
                                  name="Status"
                                  placeholder={"Status"}
                                  component={CustomSelect}
                                  options={statusOption}
                                />
                              </Col>
                              <Col
                                lg={2}
                                className="mt-1"
                                style={{ textAlign: "left" }}
                              >
                                <div
                                  onClick={() => {
                                    //setSearch("")
                                    formikFilter.setFieldValue("Status", "");
                                    formikFilter.setFieldValue("Search", "");
                                    formikFilter.setFieldValue(
                                      "SearchByColumn",
                                      ""
                                    );
                                  }}
                                >
                                  <i
                                    className="mdi mdi-filter-remove"
                                    style={{
                                      fontSize: "20px",
                                      color: "#4a539f",
                                    }}
                                  ></i>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                    <Card>
                      <CardBody>
                        <CustomTable
                          keyField="Invoice"
                          columns={columns}
                          data={invoiceListData}
                          totalSize={totalSize}
                          getData={getData}
                          search={undefined}
                        />
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </>
            ) : (
              <>
                <Row>
                  <Col
                    lg={3}
                    md={3}
                    sm={3}
                    style={{
                      height: "100%",
                    }}
                  >
                    <Row style={{ background: "#f0f0f0", marginLeft: "-25px" }}>
                      <Col
                        lg={12}
                        md={12}
                        sm={12}
                        style={{ marginTop: "20px", marginBottom: "6px" }}
                      >
                        <div className="d-flex">
                          <div style={{ width: "400px" }}>All Invoices</div>
                          <div style={{ textAlign: "right", width: "100%" }}>
                      </div>
                        </div>
                      </Col>
                      <Col
                        lg={12}
                        md={12}
                        sm={12}
                        style={{
                          borderTop: "1px solid #cacaca",
                        }}
                      >
                        {invoiceData?.map((x, i) => (
                        <Row
                            style={{
                              marginBottom: "5px",
                              marginTop: "5px",
                              backgroundColor: x.id === ID ? "#cecece96" : "",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setID(x?.id)
                              getInvoiceDetail(x?.id)
                            }}
                          >
                          <div className="col-1 col-lg-1 col-md-1 col-sm-2">
                            {" "}
                            <Input
                              type="checkbox"
                              className="form-check-input"
                              id="check"
                              checked={false}
                            />
                          </div>
                          <div className="col col-lg-6 col-md-6 col-sm-6">
                            <text>{x.invoice_no}</text>
                            <br></br>
                            <div style={{ fontSize: "10px", marginTop: "6px" }}>
                              {x.invoice_date ? moment(x.invoice_date).format("DD-MMM-YYYY").replace(/^\-/, "") : ""}
                            </div>
                          </div>
                          <div
                            className="col col-lg-5 col-md-5 col-sm-4"
                            style={{
                              marginLeft: "-2px",
                              textAlign: "end",
                              padding: "0.05rem 0.5rem",
                            }}
                          >
                            <text>Rs. {x.grand_total}</text>
                            <br></br>
                            <text style={{ fontSize: "10px", color: "grey" }}>
                              {x.invoice_status}
                            </text>
                          </div>
                        </Row>
                        ))}
                      </Col>
                    </Row>
                  </Col>

                  <Col
                    lg={9}
                    md={9}
                    sm={9}
                    style={{ borderLeft: "1px solid #cacaca" }}
                  >
                    <Row>
                      <Col
                        lg={12}
                        style={{
                          marginTop: "20px",
                        }}
                      >
                        <div style={{ fontSize: "16px", color: "grey" }}>
                        {invoiceDetail?.invoice_no}
                        </div>
                        <div style={{ textAlignLast: "end" }}>
                          <button
                            type="button"
                            className="btn"
                            style={{
                              marginTop: "-50px",
                              fontSize: "20px",
                              position: "sticky",
                              border: 0,
                            }}
                            onClick={() => setHide(1)}
                          >
                            <span>×</span>
                          </button>
                        </div>
                      </Col>
                      <Col lg={12} style={{ borderTop: "1px solid #cacaca" }}>
                        <Row>
                          <Col
                            lg={12}
                            md={12}
                            sm={12}
                            style={{
                              marginTop: "10px",
                            }}
                          >
                            <Row
                              style={{ backgroundColor: "#f8f9fa00" }}
                              className="mt-3"
                            >
                              <Col lg={1}></Col>
                              <Col
                                lg={10}
                                md={10}
                                sm={10}
                                style={{ marginLeft: "10px" }}
                              >
                                <Row>
                                  <Col lg={6} md={12} sm={12}>
                                    <text
                                      style={{
                                        fontSize: "20px",
                                        color: "black",
                                      }}
                                    >
                                      INVOICE
                                    </text>
                                    <br></br>
                                    <text>
                                      Invoice# <b>{invoiceDetail?.invoice_no}</b>
                                    </text>
                                    <Row style={{ marginTop: "10px" }}>
                                      <Col lg={2}>
                                        <button
                                          className="btn btn-primary"
                                          disabled
                                          style={{
                                            padding: "0.05rem 0.5rem",
                                            backgroundColor: "grey",
                                            borderColor: "grey",
                                          }}
                                        >
                                         {invoiceDetail?.invoice_status}
                                        </button>
                                      </Col>
                                    </Row>
                                    <Row style={{ marginTop: "15px" }}>
                                      <Col lg={6} md={12} sm={12}>
                                        <b>Invoice Amount</b>
                                      </Col>
                                      <Col lg={6} md={5} sm={12}>
                                       Rs. {invoiceDetail?.grand_total}
                                      </Col>
                                    </Row>

                                    <Row style={{ marginTop: "15px" }}>
                                      <Col lg={6} md={12} sm={12}>
                                        <b>PLACE OF SUPPLY</b>
                                      </Col>
                                      <Col lg={6} md={5} sm={12}>
                                        {invoiceDetail?.supply_state?.state_name}
                                      </Col>
                                    </Row>
                                    <Row style={{ marginTop: "15px" }}>
                                      <Col lg={6} md={12} sm={12}>
                                        <b>DATE</b>
                                      </Col>
                                      <Col lg={6} md={5} sm={12}>
                                      {invoiceDetail.invoice_date ? moment(invoiceDetail.invoice_date).format("DD-MMM-YYYY").replace(/^\-/, "") : ""}
                                      </Col>
                                    </Row>

                                    <Row style={{ marginTop: "15px" }}>
                                      <Col lg={6} md={12} sm={12}>
                                        <b>CUSTOMER NAME</b>
                                      </Col>
                                      <Col lg={6} md={5} sm={12}>
                                      {invoiceDetail?.organization?.display_name}
                                      </Col>
                                    </Row>
                                    <Row style={{ marginTop: "15px" }}>
                                      <Col lg={6} md={12} sm={12}>
                                        <b>Note</b>
                                      </Col>
                                      <Col lg={6} md={5} sm={12}>
                                      {invoiceDetail?.notes ?? '-'}
                                      </Col>
                                    </Row>
                                  </Col>
                                  <Col lg={1}></Col>
                                   
                                </Row>
                                <Row style={{ marginTop: "40px" }}>
                                  <Col lg={12}>
                                  <text
                                    style={{
                                      fontSize: "20px",
                                      color: "black",
                                      marginTop: "20px",
                                    }}
                                  >
                                    ATTACHEMENTS
                                  </text>
                                  {invoiceDetail?.files
                                    ?.length > 0 ? (
                                      invoiceDetail?.files?.map(
                                      (file, i) => {
                                        return (
                                          <Col
                                            key={file?.file?.id}
                                            lg={12}
                                            style={{ marginBottom: "20px" }}
                                          >
                                            <hr></hr>
                                            <div>
                                              <b>{file?.file?.file_name}</b>{" "}
                                              &nbsp;
                                              <a
                                                href={file?.file?.file_url}
                                                target="_blank"
                                                download={file?.file?.file_name}
                                              >
                                                <i className="ti-download" />
                                                Download
                                              </a>
                                            </div>
                                          </Col>
                                        )
                                      }
                                    )
                                  ) : (
                                    <text style={{ marginBottom: "20px" }}>
                                      {" "}
                                      No Attachement Found.
                                    </text>
                                  )}
                                  </Col>
                                </Row>

                                <Row style={{ marginTop: "40px" }}>
                                  <Col lg={12}>
                                    <p
                                      style={{
                                        fontSize: "20px",
                                        color: "black",
                                        marginTop: "20px",
                                      }}
                                    >
                                      Payment
                                    </p>

                                    {invoiceDetail?.payment != null ? (
                                      <div style={{ marginBottom: "20px" }}>
                                        <table className="table mb-0">
                                          <tbody>
                                            <tr>
                                              <th>Invoice Amount</th>
                                              <td>{invoiceDetail.payment.org_v_invoice_amount}</td>
                                            </tr>
                                            <tr>
                                              <th>Paid Amount</th>
                                              <td>{invoiceDetail.payment.org_v_paid_amount}</td>
                                            </tr>
                                            <tr>
                                              <th>Due Amount</th>
                                              <td>{invoiceDetail.payment.due_amount}</td>
                                            </tr>
                                            <tr>
                                              <th>Payment Reference</th>
                                              <td>{invoiceDetail.payment?.org_payment?.payment_ref}</td>
                                            </tr>
                                            <tr>
                                              <th>Payment Mode</th>
                                              <td>{invoiceDetail.payment?.org_payment?.payment_mode}</td>
                                            </tr>
                                            <tr>
                                              <th>Status</th>
                                              <td>{invoiceDetail.payment.status.replace(/_/g, ' ')}</td>
                                            </tr>
                                            <tr>
                                              <th>Payment Date</th>
                                              <td> 
                                              {new Date(invoiceDetail.payment?.org_payment?.payment_date).toLocaleDateString('en-GB', {
                                                day: '2-digit',month: 'short',year: 'numeric'}).replace(/ (\w{3}) /, ' $1, ')}</td>
                                            </tr> 
                                          </tbody>
                                        </table>
                                      </div>
                                    ) : (
                                      <p style={{ marginBottom: "20px" }}>No Payment Found.</p>
                                    )}
                                  </Col>
                                </Row>

                                 
                              </Col>
                              <Col lg={1}></Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </>
            )}
          </Container>
        </div>
      </Spin>
    </React.Fragment>
  );
};
InvoiceList.propTypes = {
  t: PropTypes.any,
};

export default withRouter(withTranslation()(InvoiceList));
